// import React, { useContext } from "react";
// import { Navigate, useLocation } from "react-router-dom";
// import { AppContext } from "../Context/AppContext";

// const ProtectedAdminRoute = ({ children }) => {
//   const { isAdmin } = useContext(AppContext);
//   const location = useLocation();

//   // If not admin, redirect to last valid route (e.g., /chat)
//   if (!isAdmin) {
//     const currentPath = location.pathname;
//     const fallbackPath = "/chat?new_conversation"; // or any other safe route
//     if (currentPath !== fallbackPath) {
//       return <Navigate to={fallbackPath} replace />;
//     }
//     return null;
//   }

//   return children;
// };

// export default ProtectedAdminRoute;
import React, { useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AppContext } from "../Context/AppContext";
import adminStatusService from "../services/adminStatusService";
import LoaderComponent from "../../components/Loader/LoaderComponent";

const ProtectedAdminRoute = ({ children }) => {
  const { isAdmin, setIsAdmin } = useContext(AppContext);
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const userId = localStorage.getItem("userId");

    if (!userId) {
      console.warn("No userId found in localStorage");
      setIsAdmin(false);
      setIsChecking(false);
      return;
    }

    const checkStatus = async () => {
      try {
        setIsChecking(true);
        const adminStatus = await adminStatusService.getAdminStatus(userId);
        setIsAdmin(adminStatus);
      } catch (error) {
        console.error("Failed to check admin status:", error);
        setIsAdmin(false);
      } finally {
        setIsChecking(false);
      }
    };

    checkStatus();

    // Listen for admin status changes
    const unsubscribe = adminStatusService.addListener((newAdminStatus) => {
      setIsAdmin(newAdminStatus);
    });

    return unsubscribe;
  }, [setIsAdmin]);

  // Show loading state while checking
  if (isChecking) {
    return <LoaderComponent message="Loading..." />;
  }

  if (!isAdmin) {
    return (
      <Navigate
        to="/chat?new_conversation"
        replace
        state={{ from: location }}
      />
    );
  }

  return children;
};

export default ProtectedAdminRoute;
